import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _03a01902 = () => interopDefault(import('..\\pages\\error.vue' /* webpackChunkName: "pages_error" */))
const _eaf6e290 = () => interopDefault(import('..\\pages\\have-a-card.vue' /* webpackChunkName: "pages_have-a-card" */))
const _3ad13d80 = () => interopDefault(import('..\\pages\\rejection.vue' /* webpackChunkName: "pages_rejection" */))
const _07a007d2 = () => interopDefault(import('..\\pages\\submit-claim-dysport.vue' /* webpackChunkName: "pages_submit-claim-dysport" */))
const _e9a4af7e = () => interopDefault(import('..\\pages\\submit-claim-onivyde.vue' /* webpackChunkName: "pages_submit-claim-onivyde" */))
const _7e3cd73c = () => interopDefault(import('..\\pages\\submit-claim-somatuline.vue' /* webpackChunkName: "pages_submit-claim-somatuline" */))
const _6a91b03a = () => interopDefault(import('..\\pages\\success.vue' /* webpackChunkName: "pages_success" */))
const _3fc53e9d = () => interopDefault(import('..\\pages\\upload-documents\\index.vue' /* webpackChunkName: "pages_upload-documents_index" */))
const _005b6240 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _003f333e = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _0006d53a = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _000aace4 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _34b88a21 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _8b2c556e = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/error",
    component: _03a01902,
    name: "error"
  }, {
    path: "/have-a-card",
    component: _eaf6e290,
    name: "have-a-card"
  }, {
    path: "/rejection",
    component: _3ad13d80,
    name: "rejection"
  }, {
    path: "/submit-claim-dysport",
    component: _07a007d2,
    name: "submit-claim-dysport"
  }, {
    path: "/submit-claim-onivyde",
    component: _e9a4af7e,
    name: "submit-claim-onivyde"
  }, {
    path: "/submit-claim-somatuline",
    component: _7e3cd73c,
    name: "submit-claim-somatuline"
  }, {
    path: "/success",
    component: _6a91b03a,
    name: "success"
  }, {
    path: "/upload-documents",
    component: _3fc53e9d,
    name: "upload-documents"
  }, {
    path: "/errors/400",
    component: _005b6240,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _003f333e,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _0006d53a,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _000aace4,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _34b88a21,
    name: "errors-500"
  }, {
    path: "/",
    component: _8b2c556e,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
